import styled from '@emotion/styled';
import { MenuItem } from '@mui/material';

const NoneMenuItem = styled(MenuItem)({
  fontStyle: 'italic',
});

export default NoneMenuItem;
